(() => {
  function init(root = document) {
    const covers = root.querySelectorAll('.pf-tab3-content-container img[data-href], .sb-metapal-resource-link[href]');
    for (const cover of covers) {
      let url;
      try {
        url = new URL(cover.dataset.href || cover.href, location.href);
      } catch {
        continue;
      }
      if (url.protocol !== 'https:' || url.hostname !== 'issuu.com') continue;
      const publication = url.pathname.match(/^\/sb\.care\/docs\/([^/]+)\/?$/);
      if (!publication) continue;
      const panel = cover.closest('.pf-tab3-content-container, [role="tabpanel"]');
      let label = panel?.getAttribute('aria-labelledby');
      const pageFlyPanel = Array.from(panel?.classList || []).map(name => name.match(/^pf-tab-(.+)-content-(\d+)$/)).find(Boolean);
      if (pageFlyPanel) label = `pf-tab-${pageFlyPanel[1]}-${pageFlyPanel[2]}`;
      const title = label && (document.querySelector(`label[for="${CSS.escape(label)}"]`) || document.getElementById(label));
      const params = new URLSearchParams({
        d: publication[1],
        u: 'sb.care',
        hideIssuuLogo: 'true',
        showOtherPublicationsAsSuggestions: 'false',
        hideShareButton: 'false',
        backgroundColor: '#FFFFFF',
        fullScreenShareBgColor: '#FFFFFF'
      });
      const frame = document.createElement('iframe');
      frame.className = 'sb-product-document';
      frame.title = (title?.textContent || cover.alt || document.title).trim();
      frame.src = `https://e.issuu.com/embed.html?${params}`;
      frame.loading = 'lazy';
      frame.allowFullscreen = true;
      frame.setAttribute('sandbox', 'allow-downloads allow-scripts allow-same-origin allow-popups allow-forms');
      cover.replaceWith(frame);
    }
  }
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
